"use client";

import { useTranslations } from "use-intl";
import type { KotStatus } from "@/lib/api/types";
import { cn } from "@/lib/utils";

// Status through tint, derived from existing tokens (no new colors).
const TONE: Record<KotStatus, string> = {
  NEW: "text-text-weak border-stroke-weak",
  SENT: "text-text-strong border-stroke-strong bg-fill-notice-weak",
  PREPARING: "text-text-strong border-stroke-strong bg-fill-notice-weak",
  READY: "text-honey-800 border-honey-300 bg-fill-accent-weak",
  SERVED: "text-text-disabled border-stroke-weak",
};

export function KotChip({ status }: { status?: KotStatus }) {
  const t = useTranslations("kot");
  if (!status) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-pill border px-2 py-[3px] text-sm font-semibold tracking-[0.02em]",
        TONE[status],
      )}
    >
      {t(status)}
    </span>
  );
}
